import React, { useState, useEffect, useCallback } from 'react'
import { CCard } from '@coreui/react-pro'
import { useSelector } from 'react-redux'
import { getFavProcedures } from 'src/helper/backendHelper'
import _ from 'lodash'
import CodeSearchBox from 'src/components/common/SearchBoxEncounter/CodeSearchBox'
import { cptSearch } from 'src/components/common/shared/sharedCPTLogic'
import PanelChargesDisplay from './PanelChargesDisplay'

function evaluateCPTsToShow(
  searchText,
  searchResults,
  favorites,
  currentCodeTemplate,
  currentCodeTemplateResults,
) {
  if (searchText) {
    return searchResults
  } else if (currentCodeTemplate === 'Favorites') {
    return Object.values(favorites)
  } else if (currentCodeTemplate) {
    return currentCodeTemplateResults
  } else {
    // no text or filter -> smartCPT with a default to favorites
    return searchResults.length > 0 ? searchResults : Object.values(favorites)
  }
}

async function fetchDetailedTemplateData(currentCodeTemplate, callback) {
  // if favorites, we already have them locally, so don't call for them
  if (currentCodeTemplate === 'Favorites') {
    return callback([])
  }

  await getFavProcedures({
    template: currentCodeTemplate,
  }).then((res) => {
    if (res?.status === 'success') {
      return callback(res.results)
    }
    return callback([])
  })
}

export default function PanelChargesSearchBox({ onCptToggle }) {
  const encounterType = useSelector((state) => state.sidePanel.panelEncounter?.encounterType)
  const placeOfService = useSelector((state) => state.sidePanel.panelEncounter?.place_of_service)
  const provFavCPTs = useSelector((state) => state.user.providerFavCPT)

  const [searchText, setSearchText] = useState('')
  const [searchResult, setSearchResult] = useState([])
  const [currentCodeTemplate, setCurrentCodeTemplate] = useState(null)
  const [currentCodeTemplateResults, setCurrentCodeTemplateResults] = useState([])

  const displayedCPTs = evaluateCPTsToShow(
    searchText,
    searchResult,
    provFavCPTs,
    currentCodeTemplate,
    currentCodeTemplateResults,
  )

  const searchData = async (text, placeOfService, encounterType) => {
    if (!text) {
      setSearchResult([])
      return
    }
    const newCPTs = await cptSearch({
      searchString: text,
      pos: placeOfService,
      encounterType: encounterType,
    })

    let searchedResult = (newCPTs || []).toSorted((a, b) => {
      if (a.initial_code && !b.initial_code) {
        return encounterType === 'Initial' ? -1 : 1
      } else if (!a.initial_code && b.initial_code) {
        return encounterType === 'Initial' ? 1 : -1
      }

      return 0
    })

    setSearchResult(searchedResult)
  }

  const searchTextCallback = useCallback(
    _.debounce((searchText, placeOfService, encounterType) => {
      searchData(searchText, placeOfService, encounterType)
    }, 700),
    [],
  )

  useEffect(() => {
    searchTextCallback(searchText, placeOfService, encounterType)
  }, [searchText, placeOfService, encounterType, searchTextCallback])

  return (
    <CCard id={'PanelChargeSearchBox'}>
      <CodeSearchBox
        searchText={searchText}
        setSearchText={setSearchText}
        shouldFocus={true}
        currentCodeTemplate={currentCodeTemplate}
        setCurrentCodeTemplate={(newTemplate) => {
          if (newTemplate) {
            fetchDetailedTemplateData(newTemplate, setCurrentCodeTemplateResults)
          }
          setCurrentCodeTemplate(newTemplate)
        }}
        type={'procedures'}
      />

      <PanelChargesDisplay cptTabList={displayedCPTs} onCPTToggle={onCptToggle} showFav={true} />
    </CCard>
  )
}
